import { SHOW_MODAL, CLOSE_MODAL } from './actionTypes'

export const showModal = (modal) => {
    return {
        type: SHOW_MODAL,
        modal
    }
}

export const closeModal = () => {
    return {
        type: CLOSE_MODAL
    }
}